export const CALL_GROUP_QUEUE_MIN_DATE = '11/01/2025';
export const PHONE_TREES_MIN_DATE = '09/01/2025';
